import {RouteConfig} from 'vue-router'
import Layout from '@/layout/index.vue'

const resourceRouter: RouteConfig = {
  path: '/resource',
  component: Layout,
  redirect: 'noredirect',
  name: 'resource',
  meta: {
    title: '资源管理',
    icon: 'resource'
  },
  children: [
    {
      path: 'apparatus',
      component: () => import('@/views/resource/apparatus/index.vue'),
      name: 'Apparatus',
      meta: {
        title: '器械管理'
      }
    },
    {
      path: 'equipment',
      component: () => import('@/views/resource/equipment/index.vue'),
      name: 'Equipment',
      meta: {
        title: '成绩管理'
      }
    }
  ]
}

export default resourceRouter
